import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ChunkErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    if (error.name === 'ChunkLoadError') {
      return { hasError: true };
    }
    return { hasError: false };
  }

  componentDidCatch(error: Error) {
    if (error.name === 'ChunkLoadError') {
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
